<template>
  <div class="echarts">
    <IEcharts id="graph11" :option="bar" :loading="loading" :theme="theme" :resizable="resizable" @click="onClick" />
  </div>
</template>

<script>
import IEcharts from 'vue-echarts-v3/src/full.js'
import {
  mapGetters
} from 'vuex'

export default {
  props: {
    dataset: {
      type: Array
    },
    axis: {
      type: Array
    },
    loading: Boolean,
    leftAxis: String,
    rightAxis: String,
    legendPerCol: {
      type: Number,
      default: 14
    }
  },
  components: {
    IEcharts
  },
  data() {
    const self = this
    return {
      selectedData: null,
      resizable: true,
      theme: 'dark',
      bar: {
        legend: {
          type: 'scroll',
          left: 'center',
          right: 0,
          bottom: 50
        },
        grid: [{
          left: '17%',
          right: '16%',
          bottom: 100
        }],
        dataZoom: [{
          type: 'inside',
          start: 0,
          end: 100
        },
        {
          start: 0,
          end: 100,
          handleIcon: 'M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4v1.3h1.3v-1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z',
          handleSize: '80%',
          handleStyle: {
            color: '#fff',
            shadowBlur: 3,
            shadowColor: 'rgba(0, 0, 0, 0.6)',
            shadowOffsetX: 2,
            shadowOffsetY: 2
          }
        }
        ],
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            label: {
              color: '#FFFFFF',
              fontWeight: 'bolder'
            }
          },
          position: function (pt) {
            return ['85%', '14%']
          },
          formatter: function (params, ticket, callback) {
            let res = params[0].name + '<table>'
            let column = params.length / self.legendPerCol ? params.length / self.legendPerCol : 1
            for (let i = 0; i < params.length; i++) {
              let k
              res += '<tr>'
              for (let j = 0; j < column; j++) {
                if (params[i + j] !== undefined) {
                  k = i + j
                  res +=
                    `<td style="background-color: ${params[k].color}; color: ${self.luminosity(params[i].color) ? 'white' : 'black'}">` +
                    params[k].seriesName + ': ' + (params[k].value !== undefined || params[k].value != null ? params[k].value : 'N/A') + `</td>`
                }
              }
              res += '</tr>'
              i = k
            }
            res += '</table>'
            setTimeout(function () {
              callback(ticket, res)
            }, 0)
            return res
          }
        },
        toolbox: {
          showTitle: false,
          right: 100,
          feature: {
            restore: {
              show: true
            },
            magicType: {
              type: ['line', 'bar', 'tiled', 'pie']
            },

            saveAsImage: {
              show: true
            }
          }
        },
        xAxis: {
          data: []
        },
        yAxis: [{
          type: 'value',
          name: self.rightAxis,
          min: 0,
          position: 'right',
          axisLabel: {
            formatter: '{value}',
            rotate: 30
          }
        },
        {
          type: 'value',
          name: self.leftAxis,
          min: 0,
          position: 'left',
          axisLabel: {
            formatter: '{value}',
            rotate: 30
          }
        }
        ],
        series: []
      }
    }
  },
  mounted() {
    window.addEventListener('resize', this.onResize)
    this.manageTheme(this.isDark)
  },
  destroyed() {
    window.removeEventListener('resize', this.onResize)
  },
  computed: {
    ...mapGetters(['getGeneralState']),
    isDark() {
      return this.getGeneralState('theme_dark')
    }
  },
  methods: {
    onClick(event, instance, ECharts) {
      this.theme = 'dark'
      this.selectedData = {
        index: event.dataIndex,
        value: event.name
      }
      this.$emit('coordinateSelected', this.selectedData)
    },
    onResize(event) {
      if (window.innerWidth > 750) {
        let newBar = {
          ...this.bar
        }
        let toolbox = {
          showTitle: false,
          right: 100,
          feature: {
            restore: {
              show: true
            },
            magicType: {
              type: ['line', 'bar', 'tiled', 'pie']
            },
            saveAsImage: {
              show: true
            }
          }
        }
        this.bar = {
          newBar,
          toolbox
        }
        return this.bar
      } else {
        return this.bar
      }
    },
    luminosity(color) {
      const colorHex = color.substring(1) // strip #
      const rgb = parseInt(colorHex, 16) // convert rrggbb to decimal
      const r = (rgb >> 16) & 0xff // extract red
      const g = (rgb >> 8) & 0xff // extract green
      const b = (rgb >> 0) & 0xff // extract blue

      // var luma = 0.2126 * r + 0.7152 * g + 0.0722 * b; // per ITU-R BT.709
      const luma = (r * 299 + g * 587 + b * 114) / 1000
      return luma < 130
    },
    manageTheme(theme) {
      this.theme = theme ? 'dark' : 'light'
      if (this.theme === 'dark') {
        this.bar.backgroundColor = '#242C50'
        this.bar.tooltip.axisPointer.label.color = '#000000'
        this.bar.tooltip.axisPointer.label.fontWeight = 'bolder'
      }
    }
  },
  watch: {
    dataset() {
      this.bar.series.length = 0
      this.bar.series.push(...this.dataset)
    },
    axis() {
      console.log('Axis changed')
      this.bar.xAxis.data.length = 0
      this.bar.xAxis.data = this.axis
    },
    isDark(val) {
      this.manageTheme(val)
    },
    loading() {
      console.log('LOADING...', this.loading)
    }
  }
}
</script>

<style></style>
